var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"button--filters-mobile",on:{"click":_vm.onOpenModalButtonClick}}),_vm._v(" "),(_vm.isActive)?_c('div',{staticClass:"filters-mobile"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }